import React from "react";
import styles from "../PerfilMain.module.scss";
import MisProyectos from "../MisProyectos/MisProyectos";
import MisAccesos from "../MisAccesos/MisAccesos";
import MisCotizacionesDeMateriales from "../MisCotizacionesDeMateriales/MisCotizacionesDeMateriales.js";
import MisComercioGestion from "../MisComercioGestion/MisComercioGestion.tsx";
import GestionSectionTeaser from "./GestionSectionTeaser.tsx";
import { isGestionTeaserSection } from "./gestionHubConfig.ts";
import MisAvisosLaborales from "../MisAvisosLaborales/MisAvisosLaborales.tsx";
import MisPostulacionesLaborales from "../MisPostulacionesLaborales/MisPostulacionesLaborales.tsx";
import GestionHub from "./GestionHub.tsx";
import GestionModuleHeader from "./GestionModuleHeader.tsx";
import {
  PROFILE_GESTION_SECTIONS,
  type ProfileGestionSection,
} from "../../../../utils/navigationHelpers.ts";

interface ProfileGestionProps {
  section: ProfileGestionSection | null;
  onSectionChange: (section: ProfileGestionSection | null) => void;
  perfilAjeno?: string | number;
  userData: any;
  profileVisualizerData: any;
  setInfoReady: (ready: boolean) => void;
}

const isGestionModuleSection = (
  section: ProfileGestionSection | null
): section is ProfileGestionSection =>
  section != null && PROFILE_GESTION_SECTIONS.includes(section);

const ProfileGestion: React.FC<ProfileGestionProps> = ({
  section,
  onSectionChange,
  perfilAjeno,
  userData,
  profileVisualizerData,
  setInfoReady,
}) => {
  if (!isGestionModuleSection(section)) {
    return (
      <div className={styles.sectionContent}>
        <GestionHub
          onSelectSection={(next) => onSectionChange(next)}
          setInfoReady={setInfoReady}
        />
      </div>
    );
  }

  const activeSection = section;

  return (
    <div className={styles.sectionContent}>
      <GestionModuleHeader
        section={activeSection}
        onBackToHub={() => onSectionChange(null)}
      />
      {activeSection === "proyectos" && (
        <MisProyectos
          fromPage
          myPerson
          perfilAjeno={perfilAjeno}
          userData={userData}
          setInfoReady={setInfoReady}
          currentTab="Gestión"
          gestionNavSection="proyectos"
        />
      )}
      {activeSection === "cotizaciones" && (
        <MisCotizacionesDeMateriales
          myPerson
          setInfoReady={setInfoReady}
          profileVisualizerData={profileVisualizerData}
          profileReturnTab="Gestión"
          profileReturnGestionSection="cotizaciones"
        />
      )}
      {activeSection === "accesos" && (
        <MisAccesos myPerson setInfoReady={setInfoReady} />
      )}
      {activeSection === "avisos-laborales" && (
        <MisAvisosLaborales setInfoReady={setInfoReady} />
      )}
      {activeSection === "postulaciones-laborales" && (
        <MisPostulacionesLaborales setInfoReady={setInfoReady} />
      )}
      {activeSection === "documentaciones" && isGestionTeaserSection(activeSection) && (
        <GestionSectionTeaser section={activeSection} setInfoReady={setInfoReady} />
      )}
      {activeSection === "comercio" && (
        <MisComercioGestion userData={userData} setInfoReady={setInfoReady} />
      )}
    </div>
  );
};

export default ProfileGestion;
